@let memberStatusValue = memberStatus();

<rt-dialog-body variant="white">
  <form [formGroup]="form" padding>
    <div class="multi-fields">
      <rt-form-field>
        <rt-label>{{
          'tlc.members.edit_member.account_tab.section.data.first_name' | translate
        }}</rt-label>
        <rt-input rtProtectedControl formControlName="firstName" />
      </rt-form-field>
      <rt-form-field>
        <rt-label>{{
          'tlc.members.edit_member.account_tab.section.data.last_name' | translate
        }}</rt-label>
        <rt-input rtProtectedControl formControlName="lastName" />
      </rt-form-field>
    </div>

    @if (isNotInvited()) {
      <rt-form-field>
        <rt-label
          >{{ 'tlc.members.edit_member.account_tab.section.email.heading_work_email' | translate }}
        </rt-label>
        <rt-input rtProtectedControl formControlName="email" />
        @if (emailErrorMessage()) {
          <div class="error-message">{{ emailErrorMessage() }}</div>
        }
      </rt-form-field>

      <rt-form-field>
        <rt-label
          >{{
            'tlc.members.edit_member.account_tab.section.email.heading_personal_email' | translate
          }}
        </rt-label>
        <rt-input rtProtectedControl formControlName="personalEmail" />
        @if (personalEmailErrorMessage()) {
          <div class="error-message">{{ personalEmailErrorMessage() }}</div>
        }
      </rt-form-field>
    } @else if (usesUsernameLogin()) {
      <div class="email-section section">
        <rt-form-field>
          <rt-label
            >{{ 'tlc.members.edit_member.account_tab.section.username.heading' | translate }}
          </rt-label>
          <rt-input rtProtectedControl formControlName="login" />
        </rt-form-field>
      </div>
    } @else if (hasWorkEmail()) {
      <div class="email-section section">
        <rt-form-field>
          <rt-label
            >{{ 'tlc.members.edit_member.account_tab.section.email.heading' | translate }}
          </rt-label>
          <rt-input rtProtectedControl formControlName="email" />
          @if (emailErrorMessage()) {
            <div class="error-message">{{ emailErrorMessage() }}</div>
          }
          @if (memberVerified()) {
            <rt-button class="form-button" (click)="changeEmailClicked()">
              <rt-icon name="mail-outline" />
              <div>
                {{ 'tlc.members.edit_member.account_tab.section.email.button' | translate }}
              </div>
            </rt-button>
          }
        </rt-form-field>
      </div>
    }

    @if (memberStatusValue !== TeamMemberStatus.Deactivated) {
      <div class="avatar-section section">
        <rt-heading>{{
          'tlc.members.edit_member.account_tab.section.avatar.heading' | translate
        }}</rt-heading>
        <tlc-avatar-input (avatarChanged)="cacheAvatarImg($event)" />
      </div>
    }
  </form>
</rt-dialog-body>
<rt-dialog-footer variant="white">
  <rt-button variant="plain" (click)="cancel()">{{ 'tlc.common.cancel' | translate }}</rt-button>
  <rt-button
    class="form-button"
    [disabled]="!form.dirty"
    (click)="submit()"
    [loading]="pending()"
    variant="primary"
    >{{ 'tlc.common.save' | translate }}</rt-button
  >
</rt-dialog-footer>
